// Rotation quotidienne de versets — index basé sur le jour de l'année
export const DAILY_VERSES = [
  { text: "L'Éternel est mon berger, je ne manquerai de rien.", ref: "Psaume 23:1" },
  { text: "Je puis tout par celui qui me fortifie.", ref: "Philippiens 4:13" },
  { text: "Ta parole est une lampe à mes pieds, et une lumière sur mon sentier.", ref: "Psaume 119:105" },
  { text: "Confie-toi en l'Éternel de tout ton cœur, et ne t'appuie pas sur ta sagesse.", ref: "Proverbes 3:5" },
  { text: "Ne crains rien, car je suis avec toi ; ne promène pas des regards inquiets, car je suis ton Dieu.", ref: "Ésaïe 41:10" },
  { text: "Car Dieu a tant aimé le monde qu'il a donné son Fils unique.", ref: "Jean 3:16" },
  { text: "Venez à moi, vous tous qui êtes fatigués et chargés, et je vous donnerai du repos.", ref: "Matthieu 11:28" },
  { text: "L'amour est patient, il est plein de bonté ; l'amour n'est point envieux.", ref: "1 Corinthiens 13:4" },
  { text: "Fortifie-toi et prends courage. Ne t'effraie point.", ref: "Josué 1:9" },
  { text: "Ma grâce te suffit, car ma puissance s'accomplit dans la faiblesse.", ref: "2 Corinthiens 12:9" },
  { text: "Je sais les projets que j'ai formés sur vous, projets de paix et non de malheur.", ref: "Jérémie 29:11" },
  { text: "Tout concourt au bien de ceux qui aiment Dieu.", ref: "Romains 8:28" },
  { text: "Cherchez premièrement le royaume et la justice de Dieu.", ref: "Matthieu 6:33" },
  { text: "Le juste vivra par la foi.", ref: "Romains 1:17" },
  { text: "Bénis l'Éternel, mon âme ! Que tout ce qui est en moi bénisse son saint nom !", ref: "Psaume 103:1" },
  { text: "Je suis le chemin, la vérité et la vie.", ref: "Jean 14:6" },
  { text: "Que la paix de Christ règne dans vos cœurs.", ref: "Colossiens 3:15" },
  { text: "Réjouissez-vous toujours dans le Seigneur ; je le répète, réjouissez-vous.", ref: "Philippiens 4:4" },
  { text: "L'Éternel combattra pour vous ; et vous, gardez le silence.", ref: "Exode 14:14" },
  { text: "Demeurez en moi, et je demeurerai en vous.", ref: "Jean 15:4" },
  { text: "Recommande à l'Éternel tes œuvres, et tes projets réussiront.", ref: "Proverbes 16:3" },
  { text: "Comme le cerf soupire après les eaux courantes, ainsi mon âme soupire après toi, ô Dieu.", ref: "Psaume 42:1" },
  { text: "Aime ton prochain comme toi-même.", ref: "Marc 12:31" },
  { text: "Le Seigneur est mon rocher, ma forteresse, mon libérateur.", ref: "Psaume 18:2" },
  { text: "Il y a plus de bonheur à donner qu'à recevoir.", ref: "Actes 20:35" },
  { text: "Les cieux racontent la gloire de Dieu, et l'étendue manifeste l'œuvre de ses mains.", ref: "Psaume 19:1" },
  { text: "Priez sans cesse.", ref: "1 Thessaloniciens 5:17" },
  { text: "L'Éternel te bénisse, et qu'il te garde !", ref: "Nombres 6:24" },
  { text: "Grâces soient rendues à Dieu pour son don ineffable !", ref: "2 Corinthiens 9:15" },
  { text: "Nous marchons par la foi et non par la vue.", ref: "2 Corinthiens 5:7" },
  { text: "Éternel, écoute ma prière, et que mon cri parvienne jusqu'à toi !", ref: "Psaume 102:1" },
];

export function getVerseOfTheDay() {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  const diff = now - start;
  const dayOfYear = Math.floor(diff / (1000 * 60 * 60 * 24));
  return DAILY_VERSES[dayOfYear % DAILY_VERSES.length];
}

export function getVerseOfTheWeek() {
  const now = new Date();
  // ISO week number
  const target = new Date(now.valueOf());
  const dayNr = (now.getDay() + 6) % 7;
  target.setDate(target.getDate() - dayNr + 3);
  const firstThursday = target.valueOf();
  target.setMonth(0, 1);
  if (target.getDay() !== 4) {
    target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
  }
  const weekNumber = 1 + Math.ceil((firstThursday - target) / 604800000);
  const year = now.getFullYear();
  const seed = year * 100 + weekNumber;
  return DAILY_VERSES[seed % DAILY_VERSES.length];
}

export function getNextSunday() {
  const now = new Date();
  const day = now.getDay();
  const daysUntilSunday = day === 0 ? 7 : 7 - day;
  const next = new Date(now);
  next.setDate(now.getDate() + daysUntilSunday);
  next.setHours(0, 0, 0, 0);
  return next;
}
